import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { useAuth } from '../contexts/AuthContext';
import { isPlatformStaffOrPending } from '../lib/permissions';
import PlatformMfaGate from './Security/PlatformMfaGate';

/**
 * Rutas globales de plataforma (p. ej. /admin/logs): exige sesion y staff de plataforma, ya verificado
 * (is_platform_staff === true) o con el 2FA pendiente (platform_staff_pending_mfa === true; /me sin X-MFA-Token da
 * is_platform_staff=false). Ambos pasan por PlatformMfaGate; la autorizacion real la hace el backend.
 */
export default function PlatformStaffRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return (
    <ProtectedRoute>
      {isPlatformStaffOrPending(user) ? <PlatformMfaGate>{children}</PlatformMfaGate> : <Navigate to="/announcements" replace />}
    </ProtectedRoute>
  );
}
